<app-pill *ngFor="let p of pills" [pillItem]="p"
          class="inline-block"
          [style.margin-right.rem]="0.5"
          [style.margin-bottom.rem]="0.5"
          (pillClicked)="this.pillClicked.emit($event)">
</app-pill>
